import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { Loader } from '../../../../../_components';
import { SimpleFetch, SimpleFetchResponse, store } from '../../../../../_helpers';
import DatePicker, { registerLocale } from 'react-datepicker';
import moment from 'moment';
import AsyncCreatableSelect from 'react-select/async-creatable'
import ptBR from 'date-fns/locale/pt-BR';
registerLocale('pt-BR', ptBR);

export const LogicalFields = (props) => {
  const [ isCreatedAt, setIsCreatedAt ] = useState(false);
  const [ localData, setLocalData ] = useState({});
  const [ selectedData, setSelectedData ] = useState([]);
  const [ requestingCustomFilters, setRequestingCustomFilters ] = useState(false);
  const [ availableFilters, setAvailableFilters ] = useState([]);
  const [ updatedFilters, setUpdatedFilters ] = useState();

  useEffect(() => {
    if ( !localData.filter ) return;
    
    const { data, setData } = props.parentState;
    const arr = [];
    const parentState = data.filter ? data.filter : [];

    arr.push(localData.filter);

    if ( parentState.length === 0 ) return setData({...data, filter: arr});

    parentState[props.index] = localData.filter;
    if ( parentState[props.index]["0"] ) delete parentState[props.index]["0"];

    setData({...data, filter: parentState});
  }, [localData]);

  const handleFilterChange = async (e, key) => {
    const { data, setData } = props.parentState;
    const arr = data.filter ? data.filter : {};

    setIsCreatedAt(false);
    setRequestingCustomFilters(true);
    setSelectedData(e);
    setAvailableFilters([]);
    setLocalData({});

    const req = await SimpleFetch(`GET`, {}, {}, `momentum`, `person/search/${props.domain}/filter/${e.value}`)
    if ( req.status !== 200 ) {
      SimpleFetchResponse(req, "Não foi possível listar os filtros disponíveis. Tente novamente mais tarde.", "Filtros disponíveis.");
      return setRequestingCustomFilters(false);
    }

    const literalObj = {
      "user_stored_data.navigator.mobile": () => setAvailableFilters([{label: "Sim", value: true}, {label: "Não", value: false}]),
      "user_stored_data.createdAt": () => { setAvailableFilters([{blank: true}]); setIsCreatedAt(true) },
    }

    const selectedFilter = literalObj[e.value];
    if ( selectedFilter ) {
      selectedFilter();
      setLocalData({...localData, filter: {...arr, [key]: e.value}});
      return setRequestingCustomFilters(false);
    }

    await req.data.map(item => {
      if ( !item.name || !item.value ) return;

      let obj = {
        label: (e.value !== "user_stored_data.client.location.country") ? item.name : item.emoji + ' ' + item.name ,
        value: item.value
      }

      setAvailableFilters(selectedData => [...selectedData, obj]);
    });

    setLocalData({...localData, filter: {...arr, [key]: e.value}});
    setRequestingCustomFilters(false);
  }

  const handleChange = ({value}, key) => {
    const arr = localData.filter ? localData.filter : [];
    setLocalData({...localData, filter: {...arr, [key]: value}});
  }

  const handleClick = (e) => {
    const value = e.target.getAttribute('data-condition');
    const arr = localData.filter ? localData.filter : [];

    e.target.parentNode.style.display = "none"

    setLocalData({...localData, filter: {...arr, logical: value}});
    props.handleClick(e);
  }

  const handleMultiSelect = (e, key) => {
    let arr = new Array();

    if ( !e ) return;

    e.map(item => {
      arr.push(item.value);
    });

    arr.sort((a, b) => a - b);

    const newArr = localData.filter ? localData.filter : [];
    setLocalData({...localData, filter: {...newArr, [key]: arr}});
  }

  const handleUpdateFilters = async (e) => {
    const res = await SimpleFetch(`GET`, {}, {}, `momentum`, `person/search/${store.getState().changeDomainReducer.selectedDomain.domain_uuid}/filter/${selectedData.value}?search=${e}`);
    if ( !res ) return

    console.log(localData)

    let updatedFilters = new Array();
    res.data.map((item, index) => {
      if ( !item || !item.name || !item.value ) return;

      let value = item.value;
      let label = item.name;

      updatedFilters.push({value, label});
    });

    setUpdatedFilters({updatedFilters})
    return updatedFilters
  }

  return (
    <div className="conditions__wrapper">
      {
        props.condition ?
          <div className="filter__condition" onClick={props.handleClick} data-condition="remove"  data-filter={props.index}>
            <p>
              <span>{props.condition === "and" ? "E" : "OU"}</span>
              <i className="linearicons-trash"></i>
            </p>
          </div>
        : null
      }

      {
        !requestingCustomFilters ?
          <div className="form__group form__group--inline">
            <div className="titled__group">
              <p>Filtrar por:</p>
              <Select
                options={props.selectData}
                className="basic-select"
                classNamePrefix="select"
                placeholder="Selecione o filtro"
                onChange={(e) => {handleFilterChange(e, "filter")}}
                value={selectedData}
              />
            </div>

            {
              availableFilters && availableFilters.length !== 0 ?
                !isCreatedAt ?
                  <>
                    <div className="titled__group">
                      <p>Condição:</p>
                      <Select
                        options={[
                          {label: "Igual a", value: "=="},
                          {label: "Diferente de", value: "!="},
                          {label: "Contém", value: "contain"},
                          {label: "Não contém", value: "notcontain"}
                        ]}
                        className="basic-select"
                        classNamePrefix="select"
                        placeholder="Selecione a condição"
                        onChange={(e) => {handleChange(e, "comparation")}}
                      />
                    </div>
                    <div className="titled__group">
                      <p>Valor:</p>
                      <AsyncCreatableSelect
                        className="basic-multi-select"
                        isClearable
                        isMulti
                        cacheOptions
                        onChange={(e) => handleMultiSelect(e, "value")}
                        placeholder="Selecione os valores"
                        isDisabled={!availableFilters ? true : false}
                        defaultOptions={availableFilters}
                        loadOptions={handleUpdateFilters}
                      />
                      {/**<Select
                        options={availableFilters}
                        className="basic-select"
                        classNamePrefix="select"
                        placeholder="Selecione o valor"
                        is-multiple
                        onChange={(e) => {handleChange(e, "value")}}
                      />*/}
                    </div>
                    
                    {
                      props.index === 0 ?
                        <div className="titled__group titled__group--small titled__buttons">
                          <p>Nova condição</p>
                          <button type="button" onClick={handleClick} data-condition="and" className="btn btn-white btn-icon btn-sm">E</button>
                          <button type="button" onClick={handleClick} data-condition="or" className="btn btn-white btn-icon btn-sm">OU</button>
                        </div>
                      : null
                    }
                  </>
                : <UserCreatedAtFields handleClick={handleClick} handleChange={handleChange}   index={props.index}/>
              : null
            }
          </div>
        : <Loader className="relative in-block is-blue" />
      }
    </div>
  )
}

const UserCreatedAtFields = (props) => {
  const [ condition, setCondition ] = useState()
  const [ date, setDate ] = useState({singleDate: "", between: {startDate: "", endDate: ""}})

  const handleChange = (e, key) => {
    setCondition(e);
    props.handleChange(e, key);
  }

  const handleDateChange = (e, type, key) => {
    const value = moment(e).format("YYYY-MM-DDT00:00:00") + '.000Z';
    
    if ( type === "single" ) {
      setDate({...date, singleDate: e});
      return props.handleChange({value}, key);
    }

    setDate({...date, between: {...date.between, [type]: e}});
    props.handleChange({value}, key);
  }

  return (
    <>
      <div className="titled__group">
        <p>Condição:</p>
        <Select
          options={[
            {label: "Antes de", value: "<"},
            {label: "Depois de", value: ">"},
            {label: "Entre", value: "between"},
          ]}
          className="basic-select"
          classNamePrefix="select"
          placeholder="Selecione a condição"
          defaultValue={condition}
          onChange={(e) => handleChange(e, "comparation")}
        />
      </div>

      {
        condition ?
          condition.value === "between" ?
            <>
              <div className="titled__group">
                <p>Data inicial:</p>
                <DatePicker
                  className="basic-input basic-date-input"
                  selected={date.between.startDate}
                  defaultValue={date.between.startDate}
                  onChange={(e) => handleDateChange(e, "startDate", "value")}
                  placeholder="Selecione a data"
                  dateFormat="dd/MM/yyyy"
                  startDate={date.between.startDate}
                  endDate={date.between.endDate}
                />
              </div>
              <div className="titled__group">
                <p>Data final:</p>
                <DatePicker
                  className="basic-input basic-date-input"
                  selected={date.between.endDate}
                  defaultValue={date.between.endDate}
                  onChange={(e) => handleDateChange(e, "endDate", "value2")}
                  placeholder="Selecione a data"
                  dateFormat="dd/MM/yyyy"
                  startDate={date.between.startDate}
                  endDate={date.between.endDate}
                />
              </div>
            </>
          : <div className="titled__group">
              <p>Data inicial:</p>
              <DatePicker
                className="basic-input basic-date-input"
                selected={date.singleDate}
                defaultValue={date.singleDate}
                onChange={(e) => handleDateChange(e, "single", "value")}
                placeholder="Selecione a data"
                dateFormat="dd/MM/yyyy"
              />
            </div>
        : null
      }

      {
        props.index === 0 ?
          <div className="titled__group titled__group--small titled__buttons">
            <p>Nova condição</p>
            <button type="button" onClick={(e) => props.handleClick(e)} data-condition="and" className="btn btn-white btn-icon btn-sm">E</button>
            <button type="button" onClick={(e) => props.handleClick(e)} data-condition="or" className="btn btn-white btn-icon btn-sm">OU</button>
          </div>
        : null
      }
    </>
  )
}